import React from 'react';
import _ from 'lodash';
import { Card, Grid, Icon, Label } from 'semantic-ui-react';

import TargetLink from '../../components/target-link';
import ThemeSelector from '../../themes/theme-selector';

const currentTheme = ThemeSelector.theme();

const greyOut = {
  background: '#f1f1f1',
};

const helpLinkStyle = {
  color: 'rgb(32, 196, 158)',
  float: 'right',
};

const reportLinkStyle = {
  color: 'rgb(32, 196, 158)',
};

const reportCardStyle = {
  cursor: 'initial',
};

const reportTypeLabelStyle = {
  marginTop: '5px',
  textAlign: 'center',
};

const halfPadding = {
  padding: '5px 0.7em',
};

const linkSectionStyle = {
  padding: '5px 0.7em',
};

const descriptSectionStyle = {
  'min-height': '6rem',
};

const MANAGE_ORG_LINK = '/team/manage';
const BOOK_A_DEMO = 'https://dyzio.co/book-a-demo';

const openReport = (report, campaignId) => {
  console.log('open', currentTheme.shareSite);
  window.open(`${currentTheme.shareSite}/report/${campaignId}/${report.link}`, '_blank');
};

const upgradeURLs = {
  free: '',
  premium: MANAGE_ORG_LINK,
  integration: BOOK_A_DEMO,
};

const isPremiumReport = type => _.isEqual(type, 'premium');

const isReportAvailable = (report, organisation, isShopifyCampaign, isPrestaShopCampaign) => {
  const { isFacebookAdsEnabled, isGoogleAnalyticsEnabled } = organisation || {};

  if (isPremiumReport(report.type)) return true;

  if (_.isEqual(report.type, 'integration') && _.isEqual(report.subType, 'facebook') && isFacebookAdsEnabled) return true;

  if (_.isEqual(report.type, 'integration') && _.isEqual(report.subType, 'google') && isGoogleAnalyticsEnabled) return true;

  if (_.isEqual(report.type, 'integration') && _.isEqual(report.subType, 'shopify') && isShopifyCampaign) return true;

  if (_.isEqual(report.type, 'integration') && _.isEqual(report.subType, 'prestashop') && isPrestaShopCampaign) return true;

  return false;
};

const isReportAvailableByOrg = (report, organisation) => {
  const { id } = organisation;
  if (!report.organisations) return true;
  if (_.includes(report.organisations, id)) return true;
  return false;
};

const ReportCard = (report, { id: campaignId, isShopifyCampaign, isPrestaShopCampaign }, organisation) => (
  isReportAvailableByOrg(report, organisation) && <Card
    style={isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign) ? reportCardStyle : greyOut}
    class="ui"
    color={report.color}
    onClick={isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign) ? () => _.noop() : null}
  >
    <Card.Content style={halfPadding}>
      <Card.Header>
        <Grid>
          <Grid.Row>
            <Grid.Column width={2}>
              <Icon name={report.icon} size="large" />
            </Grid.Column>
            <Grid.Column width={14}>
              {report.name}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Label color={report.color} style={reportTypeLabelStyle}>
          {_.upperFirst(report.type)}
        </Label>
      </Card.Header>
    </Card.Content>
    <Card.Content style={halfPadding}>
      <Card.Description style={descriptSectionStyle}>
        <div>{report.description}</div>
      </Card.Description>
    </Card.Content>
    <Card.Content style={linkSectionStyle}>
      <Grid>
        <Grid.Row>
          { isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign) &&
          <Grid.Column
            width={13}
            onClick={isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign) ? () => openReport(report, campaignId) : null}
          >
            <TargetLink style={reportLinkStyle} renderIf>
              Open in a new tab
            </TargetLink>
          </Grid.Column>
          }
          { !isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign) &&
          <Grid.Column width={13}>
            <TargetLink style={reportLinkStyle} renderIf href={upgradeURLs[report.type]}>
              { _.isEqual(report.type, 'premium') && 'Click here to upgrade' }
              { _.isEqual(report.type, 'integration') && 'Click here to book a call' }
            </TargetLink>
          </Grid.Column>
          }
          <Grid.Column width={3}>
            <TargetLink style={helpLinkStyle} renderIf href={report.helpLink}>
              <Icon name="help" circular />
            </TargetLink>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
);

module.exports = {
  ReportCard,
};



/** WEBPACK FOOTER **
 ** ./src/containers/report-list/report-card.js
 **/